import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue')
  },
  {
    path: '/loaduserdata',
    name: 'LoadUserData',
    component: () => import('../views/LoadUserData.vue')
  },
  {
    path: '/board-members',
    name: 'BoardMembers',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ccr" */ '../views/BoardMembers.vue')
  },
  {
    path: '/board-member-list',
    name: 'BoardMemberList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ccr" */ '../views/BoardMemberList.vue')
  },
  {
    path: '/ccr',
    name: 'CCR',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ccr" */ '../views/CCR.vue')
  },
  {
    path: '/lead-results',
    name: 'LeadResults',
    component: () => import(/* webpackChunkName: "ccr" */ '../views/LeadResults.vue')
  },
  {
    path: '/lead-inventory',
    name: 'LeadInventory',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ccr" */ '../views/LeadInventory.vue')
  },
  {
    path: '/sample-results',
    name: 'SampleResults',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ccr" */ '../views/SampleResults.vue')
  },
  {
    // Legacy upload view (CCRUpload.vue) is retired — it had no double-submit
    // guard and posted to the removed /upload-ccr endpoint. Redirect stale
    // bookmarks to the current guarded CCR flow.
    path: '/ccr-upload',
    redirect: '/ccr'
  },
  {
    // Old addresses of the PWS Report pages (renamed from "Annual Report",
    // REQ-41). Kept as redirects so bookmarks and pasted links still work;
    // vue-router carries the query string and hash across a redirect.
    path: '/annual-report',
    redirect: '/pws-report'
  },
  {
    path: '/annual-report-status',
    redirect: '/pws-report-status'
  },
  {
    path: '/pws-report',
    name: 'AnnualReport',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "annual-report" */ '../views/AnnualReport.vue')
  },
  {
    path: '/pws-report-status',
    name: 'AnnualReportStatus',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "annual-report" */ '../views/AnnualReportStatus.vue')
  },
  {
    path: '/annual-report-list',
    name: 'AnnualReportList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "annual-report-list" */ '../views/AnnualReportList.vue')
  },
  {
    path: '/rtcr',
    name: 'RTCR',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "rtcr" */ '../views/RTCR.vue')
  },
  {
    // REQ-77: the form is the Update tab of /rtcr; old links (amend_plan_id,
    // restore) land there
    path: '/rtcr-site-plan',
    name: 'RTCRSitePlan',
    redirect: (to) => ({ name: 'RTCR', query: { ...to.query, tab: 'update' } })
  },
  {
    path: '/rtcr-site-list',
    name: 'RTCRSiteList',
    component: () => import(/* webpackChunkName: "rtcr-site-plan" */ '../views/RTCRSiteList.vue')
  },
  {
    path: '/rtcr-report/:plan_id',
    name: 'RTCRReport',
    component: () => import(/* webpackChunkName: "rtcr-report" */ '../views/RTCRReport.vue')
  },
  {
    // REQ-43: the submission layout (map, all sites, wells) for the sites
    // and wells MSDH has on file now, not a submission
    path: '/rtcr-current-plan',
    name: 'RTCRCurrentPlan',
    props: { current: true },
    component: () => import(/* webpackChunkName: "rtcr-report" */ '../views/RTCRReport.vue')
  },
  {
    path: '/change-water-system',
    name: 'ChangeWaterSystem',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "change-water-system" */ '../views/ChangeWaterSystem.vue')
  },
  {
    path: '/sample-schedules',
    name: 'SampleSchedules',
    component: () => import(/* webpackChunkName: "rtcr-site-plan" */ '../views/SampleSchedules.vue')
  },
  {
    path: '/adduser',
    name: 'AddUser',
    component: () => import(/* webpackChunkName: "adduser" */ '../views/AddUser.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Settings.vue')
  },
  {
    path: '/email-test',
    name: 'EmailTest',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/EmailTest.vue')
  },
  {
    path: '/messages',
    name: 'Messages',
    component: () => import(/* webpackChunkName: "about" */ '../views/Messages.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
  },
  {
    path: '/emergency',
    name: 'Emergency',
    component: () => import(/* webpackChunkName: "help" */ '../views/Emergency.vue')
  },
  {
    path: '/surveys',
    name: 'Surveys',
    component: () => import(/* webpackChunkName: "help" */ '../views/Surveys.vue')
  },
  {
    path: '/soc-survey',
    name: 'SOCSurvey',
    component: () => import(/* webpackChunkName: "soc-survey" */ '../views/SOCSurvey.vue')
  },
  {
    path: '/soc-survey-status',
    name: 'SOCSurveyStatus',
    component: () => import(/* webpackChunkName: "soc-survey" */ '../views/SOCSurveyStatus.vue')
  },
  {
    path: '/asbestos-waiver',
    name: 'AsbestosWaiver',
    component: () => import(/* webpackChunkName: "asbestos-waiver" */ '../views/AsbestosWaiver.vue')
  },
  {
    path: '/asbestos-waiver-status',
    name: 'AsbestosWaiverStatus',
    component: () => import(/* webpackChunkName: "asbestos-waiver" */ '../views/AsbestosWaiverStatus.vue')
  },
  {
    path: '/voc-waiver',
    name: 'VOCWaiver',
    component: () => import(/* webpackChunkName: "voc-waiver" */ '../views/VOCWaiver.vue')
  },
  {
    path: '/fourlog',
    name: 'FourLogReport',
    component: () => import(/* webpackChunkName: "fourlog" */ '../views/FourLogReport.vue')
  },
  {
    path: '/wqp',
    name: 'WQPReport',
    component: () => import(/* webpackChunkName: "wqp" */ '../views/WQPReport.vue')
  },
  {
    path: '/fluoride-survey',
    name: 'FluorideSurvey',
    component: () => import(/* webpackChunkName: "fluoride-survey" */ '../views/FluorideSurvey.vue')
  },
  {
    path: '/monitoring-waivers',
    name: 'MonitoringWaivers',
    component: () => import(/* webpackChunkName: "monitoring-waivers" */ '../views/MonitoringWaivers.vue')
  },
  {
    path: '/monitoring-waiver',
    name: 'MonitoringWaiver',
    component: () => import(/* webpackChunkName: "monitoring-waivers" */ '../views/MonitoringWaiver.vue')
  },
  {
    path: '/monitoring-waiver-status',
    name: 'MonitoringWaiverStatus',
    component: () => import(/* webpackChunkName: "monitoring-waivers" */ '../views/MonitoringWaiverStatus.vue')
  },
  {
    path: '/monitoring-waiver-receipt/:waiver_id',
    name: 'MonitoringWaiverReceipt',
    props: true,
    component: () => import(/* webpackChunkName: "help" */ '../views/MonitoringWaiverReceipt.vue')
  },
  {
    path: '/pws-files',
    name: 'PWSFiles',
    component: () => import(/* webpackChunkName: "help" */ '../views/PWSFiles.vue')
  },
  {
    path: '/signout',
    name: 'SignOut',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signout" */ '../views/SignOut.vue')
  },
  {
    path: '/sigdef-responses',
    name: 'SigDefResponses',
    component: () => import(/* webpackChunkName: "sigdef" */ '../views/SigDefResponses.vue')
  }

]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

export default router
